import React from 'react';
import { Card, CardContent } from './ui/card';
import { Building2, HardHat, Triangle, Home, Calculator, PencilRuler, Palette, Handshake } from 'lucide-react';
import { mockData } from '../mock';

export const ServicesSection = () => {
  const iconComponents = {
    Building2: Building2,
    HardHat: HardHat,
    Triangle: Triangle,
    Home: Home,
    Calculator: Calculator,
    PencilRuler: PencilRuler,
    Palette: Palette
  };

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-blue-100 px-4 py-2 rounded-full mb-6">
            <PencilRuler className="w-5 h-5 text-blue-600" />
            <span className="text-blue-800 font-medium">Notre Expertise</span>
          </div>
          
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            Bureau d'études spécialisé dans le chiffrage bâtiment, les plans 2D/3D et l'architecture d'intérieur.
            Pour la réalisation, nous vous accompagnons avec notre partenaire <span className="font-semibold text-slate-800">Constriva</span>, expert en gros œuvre.
          </p>
        </div>

        {/* Services Grid - 2x2 layout */}
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 mb-16 max-w-5xl mx-auto">
          {mockData.services.map((service, index) => {
            const IconComponent = iconComponents[service.icon];
            const isConstrivaPartner = service.id === 4;
            
            return (
              <Card 
                key={service.id}
                className={`group hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border-0 bg-white/80 backdrop-blur-sm relative ${isConstrivaPartner ? 'ring-1 ring-blue-200' : ''}`}
              >
                {isConstrivaPartner && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10">
                    <div className="inline-flex items-center space-x-1.5 bg-gradient-to-r from-blue-600 to-slate-700 text-white text-xs font-semibold px-3 py-1.5 rounded-full shadow-lg whitespace-nowrap">
                      <Handshake className="w-3.5 h-3.5" />
                      <span>Partenaire Constriva</span>
                    </div>
                  </div>
                )}
                <CardContent className="p-6 lg:p-7">
                  <div className="flex flex-col space-y-5">
                    {/* Icon */}
                    <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-slate-700 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <IconComponent className="w-7 h-7 text-white" />
                    </div>
                    
                    {/* Content */}
                    <div>
                      <h3 className="text-xl font-bold text-slate-800 mb-2 group-hover:text-blue-600 transition-colors">
                        {service.title}
                      </h3>
                      
                      <p className="text-slate-600 mb-5 leading-relaxed text-sm">
                        {service.description}
                      </p>

                      {isConstrivaPartner && (
                        <div className="mt-5 p-3 rounded-xl bg-gradient-to-r from-blue-50 to-slate-50 border border-blue-100">
                          <div className="flex items-center space-x-3">
                            <div className="w-9 h-9 bg-gradient-to-br from-blue-600 to-slate-700 rounded-lg flex items-center justify-center flex-shrink-0">
                              <span className="text-white font-bold text-sm">C</span>
                            </div>
                            <div className="text-xs">
                              <p className="font-semibold text-slate-800 leading-tight">Réalisé avec Constriva</p>
                              <p className="text-slate-600">Expert BTP — Noiseau (94)</p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA block removed */}
      </div>
    </section>
  );
};